import React, { useEffect, useState } from "react";
import Drawer from "./components/Drawer/Drawer";
import LocationFinder from "./components/OrderPicker/LocationFinder/LocationFinder";
import Modal from "./components/Modal/Modal";
import "./index.scss"
import { useDispatch, useSelector } from "react-redux";
import MenuFooter from "./components/Footer/MenuFooter/MenuFooter";
import CollectionStorePicker from "./components/Drawers/CollectionStorePicker/CollectionStorePicker";
import DeliveryAddressPicker from "./components/Drawers/DeliveryAddressPicker/DeliveryAddressPicker";
import HospitalityLoginModal from "./pages/V2/Auth/HospitalityLoginModal/HospitalityLoginModal";
import { setPreparationSettings, setStoreClosed } from "../../../../../redux/companyDataSlice";
import ScheduleOrderModal from "./pages/V2/ScheduleOrderModal/ScheduleOrderModal";
import { getPreparationSettings } from "../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useHistory } from "react-router";
import MenuNavbarV3 from "./components/Navbar/MenuNavbarV3";
import LeftDrawerV3 from "./components/Drawers/LeftDrawer/LeftDrawerV3";
import ItemModal from "./components/layouts/ItemModal/ItemModal";
import config from "react-global-configuration";

const HospitalityPageWrapperV3 = ({ children }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)
    const [addDeliveryLoc, setAddDeliveryLoc] = useState(false);
    const [deliverySuccess, setDeliverySuccess] = useState(false);
    const [deliveryFailed, setDeliveryFailed] = useState(false);
    const [checkoutFailed, setCheckoutFailed] = useState("");
    const [isStoreClosed, setIsStoreClosed] = useState(false);
    const [isLeftDrawerOpen, setIsLeftDrawerOpen] = useState(false);
    const [collectionStore, setCollectionStore] = useState(false);
    const [deliveryPicker, setDeliveryPicker] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isError, setIsError] = useState(false)
    const [isOrderSuccess, setIsOrderSuccess] = useState(false);
    const [isStoreBlocked, setIsStoreBlocked] = useState(false);
    const [isCartAlertVisible, setCartAlertVisible] = useState(false)



    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);

    const selectedOffer = useSelector((state) => state.companyData.selectedOffer);
    const enableSchdeulOrders = companyDetails?.settings?.EnableScheduledOrder || false

    const dispatch = useDispatch()
    const history = useHistory()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            if (company) {
                let locationID = company?.LocationID
                getPreparationSettings(locationID).then((response) => {
                    dispatch(setPreparationSettings(response))
                })


            }
            else {
                history.push("/")
            }
        }
        fetchData()
    }, [company])
    const isOrderAvailableNow = (type) => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const orderSettings =
            type === "delivery"
                ? companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.Delivery
                : type === "collection"
                    ? companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.Takeaway
                    : companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.DineIn;

        const todaySchedule = orderSettings?.find(day => day.Day === currentDay);
        if (!todaySchedule?.OpenHours?.length) return false;

        for (let hours of todaySchedule.OpenHours) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }

        return false;
    };

    const getMappedOrderType = (orderType) => {
        switch (orderType) {
            case "delivery":
                return "DELIVERY_BY_REWARDCONSUMER";
            case "collection":
                return "TAKE_AWAY";
            case "table":
                return "DINE_IN";
            default:
                return "DELIVERY_BY_REWARDCONSUMER";
        }
    };

    const isBlockedByDateRange = (type) => {
        const orderType = getMappedOrderType(type)
        const now = new Date();
        const data = companyDetails?.settings?.OnlineOrder?.BlockOrdersByType ?? []
        for (const item of data) {
            for (const range of item.DateRanges) {
                const start = new Date(range.StartDate);
                const end = new Date(range.EndDate);
                const localStart = new Date(
                    start.getUTCFullYear(),
                    start.getUTCMonth(),
                    start.getUTCDate(),
                    start.getUTCHours(),
                    start.getUTCMinutes(),
                    start.getUTCSeconds()
                );

                const localEnd = new Date(
                    end.getUTCFullYear(),
                    end.getUTCMonth(),
                    end.getUTCDate(),
                    end.getUTCHours(),
                    end.getUTCMinutes(),
                    end.getUTCSeconds()
                );
                if (now >= localStart && now <= localEnd) {
                    if (item.BlockedFulfillmentTypes.includes(orderType)) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    const handleStoreClose = () => {
        const types = ["delivery", "collection", "table"];
        const isClosed = {};
        for (const type of types) {
            isClosed[type] = isBlockedByDateRange(type) || !isOrderAvailableNow(type);
        }
        return isClosed;
    };
    const isBlockedHour = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const today = companyDetails?.settings?.OnlineOrder?.BlockedHours.find(day => day.Day === currentDay);
        if (!today) return false;

        for (let hours of today.Time) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }
        return false;
    }
    const isStoreOpen = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const today = companyDetails?.openingHours?.find(day => day.Day === currentDay);
        if (!today || today.Closed) return false;

        for (let hours of today.OpenHours) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }
        return false;
    }
    useEffect(() => {
        if (companyDetails) {
            if (enableSchdeulOrders) {
                let sched = localStorage.getItem("schedule_order")
                if (sched) {
                    setIsStoreClosed(false)
                } else {
                    if (selectedOrderType !== "") {
                        setIsStoreClosed(!isStoreOpen() || isBlockedHour() || handleStoreClose()[selectedOrderType])
                    }
                }
            } else {
                setIsStoreClosed(!isStoreOpen())
                setIsStoreBlocked(isBlockedHour())
            }
            dispatch(setStoreClosed(handleStoreClose()))
        }
    }, [companyDetails, selectedOrderType])
    return (
        <>
            <div className="hospit-page-wrapper"
                style={{ backgroundColor: config.get('Theme') === 'Hospitality-Default-V3-REGAL' ? company?.Style?.BackgroundColor : "" }}>
                <LocationFinder visibility={addDeliveryLoc}
                    setAddDeliveryLoc={setAddDeliveryLoc}
                    onPopupClose={() => {
                        setAddDeliveryLoc(false)
                    }}

                    setDeliverySuccess={setDeliverySuccess}
                    setDeliveryFailed={setDeliveryFailed}
                />
                <CollectionStorePicker
                    isOpen={collectionStore}
                    setIsOpen={setCollectionStore}
                />
                <DeliveryAddressPicker
                    isOpen={deliveryPicker}
                    setIsOpen={setDeliveryPicker}
                />
                <Modal visibility={deliverySuccess} type="success" headerText="Great news! We deliver to your location" subText="Enjoy fresh and fast delivery straight to your doorstep. Place your order now!" onPopupClose={() => {
                    setDeliverySuccess(false)
                }} />
                <Modal visibility={deliveryFailed} type="failed" headerText="Uh-oh! Looks like we can’t reach you" subText={`Sorry, we don’t currently deliver to your area. Stay tuned for updates!`} onPopupClose={() => {
                    setDeliveryFailed(false)
                }} />
                <Modal visibility={checkoutFailed !== ""} type="failed" headerText="Sorry!" subText={checkoutFailed} onPopupClose={() => {
                    setCheckoutFailed("")
                }} />
                <Modal visibility={isCartAlertVisible} type="failed" headerText="This item can’t be added!" subText={`Sorry, Vouchers and menu items can’t be added to the cart together.`} onPopupClose={() => {
                    setCartAlertVisible(false)
                }} />
                <MenuNavbarV3
                    setIsDrawerOpen={setIsDrawerOpen}
                    setAddDeliveryLoc={setAddDeliveryLoc}
                    setIsLeftDrawerOpen={setIsLeftDrawerOpen}
                    setCollectionStore={setCollectionStore}
                    setShowLogin={setIsModalVisible}
                    setIsStoreClosed={setIsStoreClosed}
                />
                {isDrawerOpen && <Drawer setIsDrawerOpen={setIsDrawerOpen} />}
                {children}
                {!enableSchdeulOrders ? <>
                    <Modal visibility={isStoreClosed} type="closed" headerText=" We’ll Be Back Soon!" subText={
                        "We're sorry, but the store is currently closed. Please check our hours and visit us later!"
                    } onPopupClose={() => {
                        setIsStoreClosed(false)
                    }}
                        btnText={"VIEW STORE"} />
                    <Modal visibility={isStoreBlocked} headerText="We're Taking a Short Break" subText={
                        "Our store is currently closed for orders. We'll be back soon to serve you better. Thank you for your patience!"
                    } onPopupClose={() => {
                        setIsStoreBlocked(false)
                    }}
                        btnText={"VIEW STORE"} />
                </> :
                    !window.location.pathname.includes("/vouchers") && <ScheduleOrderModal visibility={isStoreClosed && !deliverySuccess && !deliveryFailed}
                        onPopupClose={() => {
                            setIsStoreClosed(false)
                        }}
                    />}
                <LeftDrawerV3
                    isOpen={isLeftDrawerOpen}
                    setIsOpen={setIsLeftDrawerOpen}
                    showLogin={() => {
                        setIsLeftDrawerOpen(false)
                        setIsModalVisible(true)
                    }}
                />
                <HospitalityLoginModal
                    visibility={isModalVisible}
                    fromCheckout={false}
                    onPopupClose={() => {
                        setIsModalVisible(false)
                    }}
                    setIsError={setIsError} />
                <ItemModal
                    visibility={selectedOffer !== ""}
                    setIsOrderSuccess={setIsOrderSuccess}
                    setCartAlertVisible={setCartAlertVisible}
                />
                <Modal visibility={isOrderSuccess} type="success"
                    headerText="Item Added to Cart!"
                    subText="Great choice! Your item is saved in the cart and ready for checkout."
                    onPopupClose={() => {
                        setIsOrderSuccess(false)
                        if (window.location.pathname.includes("/item/search")) {
                            history.push("/")
                        }
                    }}
                />
                <Modal visibility={isError} type="failed" headerText="Invalid Login" subText="Invalid email address or password"
                    onPopupClose={() => {
                        setIsError(false)
                    }}
                />

                <MenuFooter />
            </div>

        </>
    );
}

export default HospitalityPageWrapperV3;